
import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTipoZonaIva, modifyTipoZonaIva, removeTipoZonaIva, addTipoZonaIva, updateTipoZonaIvaDB } from '../../actions/tipo_zona_iva_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoZonaIVA extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTipoZonaIva();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkTipoZonaIva = (tipoZonaIva) => {
        if (this.props.tiposZonaIva.find(c => (c.descr === tipoZonaIva.descr) && (c.id !== tipoZonaIva.id))) {
            this.messageDialog(`Ya existe un tipo de zona de IVA ${tipoZonaIva.descr}`);
            return false;
        } else if (!tipoZonaIva.descr.trim()) {
            this.messageDialog('Por favor, introduzca un Nombre');
            return false;
        }

        else return true;
    };

    addNewTipoZonaIva = tipoZonaIva => {
        this.props.setSaveState(true);
        this.props.addTipoZonaIva(tipoZonaIva);
    };

    newTipoZonaIva = () => {
        this.props.openDialog('EditCvTipoZonaIva', {
            cvTipoZonaIva: {},
            okHandler: this.addNewTipoZonaIva,
            checkTipoZonaIva: this.checkTipoZonaIva,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.props.tiposZonaIva[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoZonaIva(updatedRow);
        // };

        let updatedRow = update(this.props.tiposZonaIva[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoZonaIva(updatedRow);

    };

    handleDeleteRow = tipoZonaIva => {
        this.props.setSaveState(true);
        this.props.removeTipoZonaIva(tipoZonaIva);
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                    <NeuriteGrid
                        id="m_a_t_z_i"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 115 }
                        ]}
                        rows={this.props.tiposZonaIva}
                        height={500}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoZonaIva}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tiposZonaIva.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTipoZonaIvaDB(this.props.tiposZonaIva)
                }}>Guardar</Button>
            </div>
        );

    };

};

MaeAuxiliaresTipoZonaIVA.propTypes = {
    //state
    tipoZonaIVA: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTipoZonaIva: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoZonaIva: PropTypes.func.isRequired,
    removeTipoZonaIva: PropTypes.func.isRequired,
    addTipoZonaIva: PropTypes.func.isRequired,
    updateTipoZonaIvaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tiposZonaIva: state.tipoZonaIva.tiposzona,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTipoZonaIva,
        openDialog,
        hideDialog,
        modifyTipoZonaIva,
        removeTipoZonaIva,
        addTipoZonaIva,
        updateTipoZonaIvaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoZonaIVA));